export const formattedDateByTimeZone = (date) => {
  const formattedDate = new Date(date)
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const dayAndMonth = new Intl.DateTimeFormat('en-US', {
    day: 'numeric',
    month: 'short',
    timeZone: timezone,
  }).format(formattedDate)

  const year = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
  }).format(formattedDate)

  const time = Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: timezone,
  }).format(formattedDate)

  const dateWithSlashes = new Intl.DateTimeFormat('en-US').format(formattedDate)

  return { dayAndMonth, year, time, dateWithSlashes }
}
